<template>
	<div
		class="p-6 transition-all duration-500 border shadow-xl sm:p-8 lg:p-10 sm:shadow-2xl bg-white/90 backdrop-blur-md rounded-2xl sm:rounded-3xl border-white/40 hover:shadow-blue-500/10 animate-fade-in-up"
	>
		<div class="mb-6 text-center sm:mb-8">
			<h2 class="mb-3 text-2xl font-bold sm:text-3xl text-slate-900">
				Payment & Confirmation
			</h2>
			<p class="max-w-2xl mx-auto text-base sm:text-lg text-slate-600">
				Review your order details and proceed to make payment
			</p>
		</div>

		<div
			class="max-w-xl p-6 mx-auto mb-6 transition-all duration-500 bg-white border shadow-md sm:p-8 sm:mb-8 rounded-xl sm:rounded-2xl border-slate-100"
		>
			<h4 class="mb-4 text-xl font-bold sm:text-2xl text-slate-900">
				Order Summary
			</h4>
			<div
				class="space-y-3 text-base sm:space-y-4 sm:text-lg text-slate-700"
			>
				<div class="flex justify-between">
					<strong>Selected Product:</strong>
					<span>{{
						selectedProduct ? selectedProduct.name : 'N/A'
					}}</span>
				</div>
				<div class="flex justify-between">
					<strong>Premium:</strong>
					<span
						>KES
						{{
							selectedProduct
								? selectedProduct.premium.toLocaleString()
								: 'N/A'
						}}</span
					>
				</div>
				<div class="flex justify-between">
					<strong>Vehicle Value:</strong>
					<span
						>KES
						{{
							vehicleValue ? vehicleValue.toLocaleString() : 'N/A'
						}}</span
					>
				</div>
				<div class="flex justify-between">
					<strong>Cover Type:</strong>
					<span>{{
						selectedCoverType
							? selectedCoverType.charAt(0).toUpperCase() +
								selectedCoverType.slice(1)
							: 'N/A'
					}}</span>
				</div>
			</div>
		</div>

		<div class="max-w-lg mx-auto text-center">
			<p
				v-if="paymentStatus === 'pending'"
				class="mb-5 text-lg font-semibold text-blue-600 sm:text-xl"
			>
				Please proceed with the payment.
			</p>
			<p
				v-else-if="paymentStatus === 'success'"
				class="mb-5 text-xl font-bold text-green-600 sm:text-2xl"
			>
				Payment Successful! Your policy is being processed.
			</p>
			<p
				v-else-if="paymentStatus === 'failed'"
				class="mb-5 text-xl font-bold text-red-600 sm:text-2xl"
			>
				Payment Failed. Please try again.
			</p>

			<button
				@click="processPayment"
				:disabled="
					paymentStatus === 'success' ||
					paymentStatus === 'processing'
				"
				:class="[
					'w-full sm:w-auto px-6 py-3 sm:px-8 sm:py-4 text-base sm:text-lg rounded-full text-white font-semibold shadow-lg transition-colors duration-300',
					paymentStatus === 'pending' || paymentStatus === 'failed'
						? 'bg-blue-600 hover:bg-blue-700'
						: 'bg-gray-400 cursor-not-allowed',
				]"
			>
				{{
					paymentStatus === 'pending'
						? 'Make Payment'
						: paymentStatus === 'processing'
							? 'Processing...'
							: 'Payment Complete'
				}}
			</button>

			<div
				class="flex flex-col-reverse justify-between gap-4 mt-6 sm:flex-row sm:mt-8"
			>
				<button
					type="button"
					@click="previous"
					:disabled="paymentStatus === 'success'"
					class="w-full px-6 py-3 text-base font-semibold text-blue-600 transition-colors duration-300 border-2 border-blue-600 rounded-full sm:w-auto sm:text-lg hover:bg-blue-50"
				>
					Back
				</button>
				<button
					v-if="paymentStatus === 'success'"
					@click="finishFlow"
					class="w-full px-6 py-3 text-base font-semibold text-white transition-colors duration-300 bg-blue-600 rounded-full shadow-lg sm:w-auto sm:text-lg hover:bg-blue-700"
				>
					Go to Dashboard
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import motorCommercialService from '../motorCommercialService';

export default {
	name: 'PaymentConfirmation',
	props: [
		'selectedProduct',
		'selectedCoverType',
		'vehicleValue',
		'paymentStatus',
	],
	methods: {
		async processPayment() {
			this.$store.commit('motorPrivate/SET_PAYMENT_STATUS', 'processing');

			try {
				// Simulating API call
				await new Promise((resolve) => setTimeout(resolve, 2000));
				this.$store.commit(
					'motorPrivate/SET_PAYMENT_STATUS',
					'success',
				);
				alert(
					'Payment successful! Your policy will be issued shortly.',
				);
			} catch (error) {
				this.$store.commit('motorPrivate/SET_PAYMENT_STATUS', 'failed');
				console.error('Payment failed:', error);
				alert('Payment failed. Please try again.');
			}
		},
		previous() {
			this.$emit('previous-step');
		},
		finishFlow() {
			this.$router.push('/main/dashboard');
			this.$store.dispatch('motorPrivate/resetFlow');
		},
	},
};
</script>

<style scoped>
@keyframes fade-in-up {
	from {
		opacity: 0;
		transform: translateY(30px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}
.animate-fade-in-up {
	animation: fade-in-up 0.8s ease-out forwards;
}
.backdrop-blur-md {
	backdrop-filter: blur(12px);
	-webkit-backdrop-filter: blur(12px);
}

@media (max-width: 640px) {
	button {
		min-height: 48px;
	}

	.p-6 {
		padding: 1.25rem;
	}

	.max-w-xl {
		max-width: 100%;
	}
}

@media (max-width: 400px) {
	h2 {
		font-size: 1.5rem;
	}

	.text-base {
		font-size: 0.9375rem;
	}

	.text-lg {
		font-size: 1rem;
	}

	.text-xl {
		font-size: 1.25rem;
	}
}
</style>
